import { useRef } from 'react';
import { createLogger } from '@/utils/logger';

export default function useLogger(key: string) {
  return useRef(createLogger(key));
}
